import { MeetingType as ApiMeetingType } from "../api/meeting_types";

export interface MeetingType {
  id: string;
  title?: string;
  shortDescription?: string;
  description?: string;
  calendarEventTitle?: string;
  notificationTitle?: string;
  notificationDescription?: string;
}

export const fromApiMeetingType = (
  apiMeetingType: ApiMeetingType
): MeetingType => {
  return {
    id: apiMeetingType.id,
    title: apiMeetingType.title,
    shortDescription: apiMeetingType.shortDescription,
    description: apiMeetingType.description,
    calendarEventTitle: apiMeetingType.calendarEventTitle,
    notificationTitle: apiMeetingType.notificationTitle,
    notificationDescription: apiMeetingType.notificationDescription,
  };
};
